export const LOGIN_ACTION = "LOGIN_ACTION";
export const LOGIN_ACTION_SUCCESS = "LOGIN_ACTION_SUCCESS";
export const LOGIN_ACTION_FAIL = "LOGIN_ACTION_FAIL";
export const LOGOUT_ACC = "LOGOUT_ACC";


// actionTypes.js
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

// actionTypes.js
export const FETCH_TOKEN_REQUEST = "FETCH_TOKEN_REQUEST";
export const FETCH_TOKEN_SUCCESS = "FETCH_TOKEN_SUCCESS";
export const FETCH_TOKEN_FAILURE = "FETCH_TOKEN_FAILURE";

//Loader

export const SHOW_LOADER_LOGIN = "SHOW_LOADER_LOGIN";
export const HIDE_LOADER_LOGIN = "HIDE_LOADER_LOGIN";

export const LOGIN_LOADER_STUTAS = "LOGIN_LOADER_STUTAS";
